<template>
    <div>
        <b-card class="border-none nopadding nopadding-y p-0 m-0">
            <p>
                <b-row no-gutters>
                    <b-col>
                        <b-alert :show="true" variant="secondary">
                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                <b-col>
                                    <span class="h6"> Select the spreadsheet to analyse, we will check the sheet and
                                        validate the
                                        BL load to determine if it can be processed.
                                    </span></b-col></b-row>
                        </b-alert></b-col>
                </b-row>

                <b-card-body>
                    <div>
                        <b-row>
                            <b-col cols="12" sm="6" md="6" xl="6">
                                <b-form-group label="Click x to remove or browse for document upload..."
                                    label-size="sm">
                                    <b-input-group>

                                        <b-input-group-prepend>
                                            <b-button size="sm" title="delete" variant="outline-danger"
                                                @click="fileUpload_clear">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-prepend>
                                        <b-form-file class="ml-1 z-0" id="file-small" size="sm" ref="file-input"
                                            :multiple="false" no-drop @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                                " :disabled="fileUpload ? true : false"></b-form-file>
                                        <b-input-group-append>
                                            <b-button class="ml-1" size="sm" title="view file" variant="outline-primary"
                                                @click="fileUpload_view" :disabled="!fileUpload">
                                                <i class="fa fa-download"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-row>
                                    <b-col>
                                        <b-form-group label="Type" label-for="type" label-cols="12">
                                            <treeselect instanceId="type" type="number" v-model="item.type"
                                                :clearable="true" :options="type_options" :disabled="true"></treeselect>
                                        </b-form-group></b-col>
                                    <b-col>
                                        <b-form-group label="Size" label-for="size" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.size" placeholder="Enter size"
                                                    size="sm" :disabled="true"></b-form-input>

                                            </b-input-group> </b-form-group></b-col>

                                </b-row>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Source Filter" label-for="sourcetype" label-cols="12">
                                    <b-form-input v-model="sourcetype" size="sm" :disabled="true"
                                        placeholder="Not detected">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">

                        <r-table :refid="loaderbl.refid" :busy="loaderbl.busy" :icon="loaderbl.icon" :showtoolbar="true"
                            :showsheets="true" :showpages="false" :showfab="false" :tools="loaderbl.tools"
                            :toolbar="loaderbl.toolbar" :fields="loaderbl.fields" :items="loaderbl.items"
                            :dirty="loaderbl.dirty" @click="loaderbl_click" @select="loaderbl_select" />

                    </b-overlay>

                    <b-row class="px-0 mt-3">
                        <b-col>
                            <b-alert :show="message_sheet != null" variant="danger">
                                <b-row no-gutters align-v="center">
                                    <b-col cols="auto" class="mr-3">
                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                    <b-col>
                                        <span v-html="message_sheet"></span></b-col></b-row>
                            </b-alert></b-col>
                    </b-row>

                    <b-row no-gutters>
                        <b-col cols="auto" class="mr-3">
                            <b-button squared size="sm" variant="primary" @click="postit_saveit"
                                v-if="user.permissions.includes('boughtledger.save')" :disabled="postit_disabled">
                                <i class="fa fa-check"></i>
                                Post It
                            </b-button>
                        </b-col>
                        <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-body>
            </p>
        </b-card>

    </div>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "i-loaderbl",

    data() {
        return {
            tabindex: 1,
            message: "",
            busy: false,
            readonly: false,
            postit_disabled: true,
            load_busy: false,

            page: 1,
            item: {
                ref: "",

            },
            summary: "Summary...",
            data: null,
            selectedComponent: null,

            loaderbl: {
                title: "BL Loader Import",
                icon: "fa fa-cloud-upload",
                debounce: 500,
                busy: false,
                dirty: false,
                page: 1,
                tools: "go,export,copy,textsize,error,sheet_1",
                toolbar: [],
                fields: [],
                items: [],
                loaded: []
            },
        };
    },
    props: {
        value: { type: Object, required: true },
        title: { type: String, default: "" },
    },

    watch: {

        tabindex: {
            immediate: true,
            async handler(newVal, oldVal) {

            }
        },
        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                this.state = null
                this.activesheet.fields = []
                this.activesheet.items = []
                this.item.type = 0;
                if (newVal) {
                    this.item.name = newVal.name;
                    this.item.size = newVal.size;
                    await this.preview(JSON.stringify(newVal));
                } else {
                    this.item.name = null;
                    this.item.size = 0;
                    this.message_sheet = null
                }
            },
        },
    },
    methods: {
        async saveit() {

            let variables = {}
            let rows = []

            this.message = ""
            console.log('saveit')

            this.activesheet.busy = true;
            variables.rows = this.cleanit(this.sheets)
            variables.apply = true
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                                mutation tickets_refunds($rows: [FilePreview_input], $apply: Boolean) {
                                    tickets_refunds(rows: $rows, apply: $apply) {
                                        sheet
                                        fields
                                        items
                                        type
                                    }
                                }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Posted it.</span>";

                this.sheets = response.data.tickets_refunds
                this.activesheet.fields = JSON.parse(response.data.tickets_refunds[0].fields);
                this.activesheet.items = JSON.parse(response.data.tickets_refunds[0].items);
                let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                if (find) {
                    find.label = response.data.tickets_refunds[0].sheet
                }
                this.posted = true

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.activesheet.busy = false;

        },

        async preview(data) {
            this.activesheet.busy = true;
            this.message_sheet = null
            this.message = null

            let variables = {
                data: JSON.stringify(this.fileUpload),
                state: this.state,
                type: this.sourcetype
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query file_preview($data: String, $state: String, $type: String) {
                            file_preview(data: $data, state: $state, type: $type) {
                                sheet
                                fields
                                items
                                type
                            }
                        }
                    `,
                    variables,
                });

                if (response.data.file_preview[0].type == this.sourcetype) {
                    this.sheets = response.data.file_preview
                    this.activesheet.fields = JSON.parse(response.data.file_preview[0].fields);
                    this.activesheet.items = JSON.parse(response.data.file_preview[0].items);
                    this.activesheet.loaded = this.activesheet.items
                    let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                    if (find) {
                        find.label = response.data.file_preview[0].sheet
                    }
                    this.posted = false

                } else {
                    this.message_sheet = "Sheet could not be loaded, cannot load a sheet of type '" + response.data.file_preview[0].type + "' for '" + this.sourcetype + "' source processing.";
                }

            } catch (error) {
                console.log(error);
            }
            this.activesheet.busy = false;

        },
    }
};
</script>

<style></style>